import { createFileRoute } from '@tanstack/react-router';
import { GroupedShipments } from '@uturn/portal/modules/shipments';

export const Route = createFileRoute('/_protected/shipments/(overview)/groups')(
	{
		component: GroupedShipments,
	},
);
